
import type { Promotion } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ToolsMessages } from '../../models/i18n/tools.messages'
import type { PromotionDomainService } from '../../services/interfaces/domain/promotion-domain.service'
import { DomainObjectUtils } from '@empathyco/playboard-core-domain'
import { computed, defineComponent, ref } from 'vue'
import EpbTextbox from '../../components/shared/epb-textbox/epb-textbox.component.vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'

export default defineComponent({
  name: 'PromotionUrlTextbox',
  components: {
    EpbTextbox,
  },
  props: {
    value: {
      type: Object as PropType<Promotion['setting']>,
      required: true,
    },
    messages: {
      type: Object as PropType<ToolsMessages['promotions']['aside']>,
      required: true,
    },
    disabled: Boolean,
    required: Boolean,
  },
  emits: {
    input: (value: Promotion['setting']) => {},
  },
  setup(props, { emit }) {
    const domainService = CONTAINER.get<PromotionDomainService>(TYPES.PromotionDomainService)

    const initialUrlValue = props.value.config.url
    const formValue = ref<Promotion['setting'] | undefined>(DomainObjectUtils.clone(props.value))

    const onChange = (value: string): void => {
      formValue.value.config.url = value?.trim()
      emit('input', { ...props.value, config: { ...props.value.config, url: value } })
    }

    function isUrlValid(url: string): boolean {
      if (url === initialUrlValue) {
        return true
      }
      return domainService.isUrlValid(url)
    }

    const getErrorMessage = computed(() => {
      return !isUrlValid(formValue.value.config.url) ? props.messages.url.error : undefined
    })

    return {
      baseClass: 'promotions-url-textbox',
      getErrorMessage,
      formValue,
      isUrlValid,
      onChange,
    }
  },
})
